module.exports = __webpack_public_path__ + "static/media/morning_sea_wave.0fca0e0b.mp3";